// extracted by mini-css-extract-plugin
export default {"shipments":"shipments-module--shipments--ae010","dateRangeSelector":"shipments-module--dateRangeSelector--e574d"};